/*
 *
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AccountingTransaction from './accounting-transaction';
import AccountingTransactionDetail from './accounting-transaction-detail';
import AccountingTransactionUpdate from './accounting-transaction-update';
import AccountingTransactionDeleteDialog from './accounting-transaction-delete-dialog';

const AccountingTransactionRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AccountingTransaction />} />
    <Route path="new" element={<AccountingTransactionUpdate />} />
    <Route path=":id">
      <Route index element={<AccountingTransactionDetail />} />
      <Route path="edit" element={<AccountingTransactionUpdate />} />
      <Route path="delete" element={<AccountingTransactionDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AccountingTransactionRoutes;
